import type { ButtonClickedPayload } from '../types';
import { fromUnixTime, getFormattedDate } from '@/resources/helpers';
import { useNuxtApp, useAppConfig } from '#imports';
import { setTrackingData } from '@/resources/tracking';

export const sendButtonClickedEvent = ({
  pagePath,
  pageUrl,
  pageTitle,
  targetUrl,
  targetPath,
  pageType,
  label,
  citySelected,
  listId,
  category,
  elementId,
  hostId,
  locationCity,
  motivLevel,
  dateSelected,
  itemName,
  buttonAction,
  value
}: ButtonClickedPayload) => {
  const { $router, $mixpanel } = useNuxtApp();

  const config = useAppConfig();
  const formatedDate =
    dateSelected && dateSelected !== undefined
      ? [getFormattedDate(fromUnixTime(new Date(dateSelected)), 'yyyy-MM-dd', config.timeZone)]
      : undefined;

  $mixpanel.track('button_clicked', {
    eventProps: {
      pagePath: pagePath ?? 'client_url',
      pageUrl,
      pageType: pageType ?? setTrackingData($router.currentRoute?.value?.name),
      pageTitle,
      targetUrl,
      targetPath: $router.currentRoute?.value.path,
      label,
      citySelected,
      listId,
      category,
      elementId,
      hostId,
      locationCity,
      motivLevel,
      dateSelected: formatedDate,
      itemName,
      buttonAction,
      value
    }
  });
};
